module.exports = __webpack_public_path__ + "static/Calibre-SemiboldItalic-71941c0c0420e703494d6e2a62bc12d4.ttf";